import React,{useState} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiActivity,FiClock,FiDownload,FiPlay,FiUsers,FiAward,FiBookOpen,FiFileText,FiX,FiChevronLeft,FiChevronRight,FiEye}=FiIcons;

const EngagementTabs=()=> {
  const [activeTab,setActiveTab]=useState('live-engagement');
  const [showLiveEngagementModal,setShowLiveEngagementModal]=useState(false);
  const [currentImageIndex,setCurrentImageIndex]=useState(0);

  const liveEngagementExamples=[
    {
      id: 1,
      title: 'Structuring Effective Prompts Session',
      image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758223411183-image.png',
      description: 'Live AI prompting session with active Q&A participation and real-time engagement from actuarial professionals'
    },
    {
      id: 2,
      title: 'Interactive Business Strategy Discussion',
      image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758223422843-image.png',
      description: 'Professional presentation with live audience engagement, featuring Q&A interactions and expert responses'
    },
    {
      id: 3,
      title: 'AI: Actuarial Intelligence From Workbooks to Workflows',
      image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758223697466-image.png',
      description: 'Trevor Booth session with active Q&A discussion on agentic AI development and technical implementation for actuaries'
    },
    {
      id: 4,
      title: 'Actuarial AI Agents - Live and in Action',
      image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758223727436-image.png',
      description: 'Jared Spowart presenting AI agents with live audience engagement and technical Q&A about Python modeling agents'
    },
    {
      id: 5,
      title: 'AI in Insurance - Opportunities and Risk Management',
      image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758223752151-image.png',
      description: 'Sophie Wright engaging with audience on AI risk mitigation and governance, featuring active discussion on machine learning applications'
    },
    {
      id: 6,
      title: 'Model Better to Steer Smarter: ML & AI Applications',
      image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758223791821-image.png',
      description: 'Bruno Bêcha from Akur8 presenting with sponsor branding visible, demonstrating professional summit quality with active Q&A participation'
    }
  ];

  const tabs=[ 
    {id: 'live-engagement',label: 'Live Event Engagement',icon: FiPlay},
    {id: 'additional-benefits',label: 'Additional Membership Benefits',icon: FiAward},
    {id: 'top-downloads',label: 'Top Media Downloads',icon: FiDownload} 
  ];

  const downloadData=[ 
    {title: 'Actuarial AI Agents - Live and in Action',downloads: 375,type: 'Presentation'},
    {title: 'Advanced LLM Prompting Techniques for Actuaries',downloads: 340,type: 'Presentation'},
    {title: 'OpenAI: A practical guide to building agents',downloads: 263,type: 'Guide'},
    {title: 'Decoding AI era technologies',downloads: 254,type: 'Presentation'},
    {title: 'AI-Powered Actuarial Delivery',downloads: 246,type: 'Presentation'},
    {title: 'Extinct or Evolved',downloads: 237,type: 'Presentation Slides'},
    {title: 'The Actuarial Engineer',downloads: 229,type: 'Resource'},
    {title: 'AI in Action: Creating Value for L&H Insurers Where it Matters Most',downloads: 228,type: 'Presentation'},
    {title: 'The Prompt Report: A Systematic Survey of Prompt Engineering Techniques',downloads: 226,type: 'Report'},
    {title: 'AWS: an Executive\'s Guide to Agentic AI',downloads: 221,type: 'Guide'} 
  ];

  const nextImage=()=> {
    setCurrentImageIndex((prev)=> (prev + 1) % liveEngagementExamples.length);
  };

  const prevImage=()=> {
    setCurrentImageIndex((prev)=> (prev - 1 + liveEngagementExamples.length) % liveEngagementExamples.length);
  };

  const openLiveEngagementModal=()=> {
    setShowLiveEngagementModal(true);
    setCurrentImageIndex(0);
  };

  const closeLiveEngagementModal=()=> {
    setShowLiveEngagementModal(false);
  };

  const renderTabContent=()=> {
    switch (activeTab) {
      case 'live-engagement': 
        return ( 
          <motion.div 
            className="bg-gradient-to-br from-proactuary-blue-600/30 to-proactuary-green-600/30 rounded-xl p-6" 
            initial={{opacity: 0,y: 20}} 
            animate={{opacity: 1,y: 0}} 
            exit={{opacity: 0,y: -20}} 
          > 
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center"> 
              <SafeIcon icon={FiPlay} className="text-proactuary-blue-400 mr-3" /> 
              Live Event Performance 
            </h3> 
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6"> 
              {[ 
                {number: '17',label: 'Expert-Led Sessions',icon: FiActivity},
                {number: 'High',label: 'Live Interaction Rate',icon: FiUsers},
                {number: 'Strong',label: 'Live Attendance Rate',icon: FiUsers,clickable: true} 
              ].map((stat,index)=> ( 
                <motion.div 
                  key={index} 
                  className={`glass-effect rounded-lg p-4 text-center ${stat.clickable ? 'cursor-pointer hover:bg-white/20 hover:scale-105 border-2 border-proactuary-green-400/50 hover:border-proactuary-green-400' : ''} transition-all duration-300`}
                  initial={{opacity: 0,scale: 0.8}} 
                  animate={{opacity: 1,scale: 1}} 
                  transition={{delay: index * 0.1}} 
                  onClick={stat.clickable ? openLiveEngagementModal : undefined}
                  whileHover={stat.clickable ? {scale: 1.05} : {}}
                  whileTap={stat.clickable ? {scale: 0.95} : {}}
                > 
                  <SafeIcon icon={stat.icon} className="text-proactuary-blue-400 text-2xl mx-auto mb-2" /> 
                  <div className="text-2xl font-bold text-white mb-1">{stat.number}</div> 
                  <div className="text-sm text-white/80">{stat.label}</div>
                  {stat.clickable && (
                    <div className="mt-2 flex items-center justify-center">
                      <SafeIcon icon={FiEye} className="text-proactuary-green-400 text-sm mr-1" />
                      <span className="text-xs text-proactuary-green-300">Click to view examples</span>
                    </div>
                  )}
                </motion.div> 
              ))} 
            </div> 
            <p className="text-center text-white/90 text-lg"> 
              <strong>Strong live attendance</strong> with sustained engagement throughout the day. Viewers actively participated in Q&A sessions. 
            </p> 
          </motion.div> 
        );
      case 'additional-benefits': 
        return ( 
          <motion.div 
            className="bg-gradient-to-br from-proactuary-green-600/30 to-proactuary-blue-600/30 rounded-xl p-6" 
            initial={{opacity: 0,y: 20}} 
            animate={{opacity: 1,y: 0}} 
            exit={{opacity: 0,y: -20}} 
          > 
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center"> 
              <SafeIcon icon={FiAward} className="text-proactuary-green-400 mr-3" /> 
              Additional Membership Benefits 
            </h3> 
            {/* Three Benefits Boxes */} 
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6"> 
              {[ 
                {title: '24hrs+ Extended Access',subtitle: '24-hour replays available with extended access for some members',icon: FiClock},
                {title: 'CPD Certificates',subtitle: 'Professional completion certificates with detailed attendance tracking and CPD credits',icon: FiAward},
                {title: 'Credit Categories',subtitle: '7 professional development categories covering AI applications,methodology,and future skills',icon: FiBookOpen} 
              ].map((benefit,index)=> ( 
                <motion.div 
                  key={index} 
                  className="glass-effect rounded-lg p-4 text-center" 
                  initial={{opacity: 0,scale: 0.8}} 
                  animate={{opacity: 1,scale: 1}} 
                  transition={{delay: index * 0.1}} 
                > 
                  <SafeIcon icon={benefit.icon} className="text-proactuary-green-400 text-2xl mx-auto mb-3" /> 
                  <div className="text-lg font-bold text-white mb-2">{benefit.title}</div> 
                  <div className="text-sm text-white/80 leading-relaxed">{benefit.subtitle}</div> 
                </motion.div> 
              ))} 
            </div> 
            {/* Certificate Sample */} 
            <div className="mb-6"> 
              <h4 className="text-xl font-bold text-white mb-4 flex items-center"> 
                <SafeIcon icon={FiAward} className="text-proactuary-green-400 mr-2" /> 
                Sample Professional Certificate 
              </h4> 
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6"> 
                {/* Completion Certificate */} 
                <motion.div 
                  className="glass-effect rounded-lg p-4 border border-proactuary-green-500/30" 
                  initial={{opacity: 0,scale: 0.9}} 
                  animate={{opacity: 1,scale: 1}} 
                  transition={{delay: 0.4}} 
                > 
                  <div className="text-center mb-3"> 
                    <div className="text-lg font-semibold text-white">Certificate of Completion</div> 
                    <div className="text-sm text-white/70">Professional CPD Credits</div> 
                  </div> 
                  <img 
                    src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758207216073-image.png" 
                    alt="Certificate of Completion showing 11 CPD credits across 7 categories" 
                    className="w-full h-auto rounded-lg border border-white/20" 
                  /> 
                  <div className="text-xs text-white/70 mt-2 text-center"> 
                    Professional certificate with detailed credit breakdown 
                  </div> 
                </motion.div> 
                {/* Attendance Certificate */} 
                <motion.div 
                  className="glass-effect rounded-lg p-4 border border-proactuary-blue-500/30" 
                  initial={{opacity: 0,scale: 0.9}} 
                  animate={{opacity: 1,scale: 1}} 
                  transition={{delay: 0.5}} 
                > 
                  <div className="text-center mb-3"> 
                    <div className="text-lg font-semibold text-white">Attendance Certificate</div> 
                    <div className="text-sm text-white/70">Detailed Session Tracking</div> 
                  </div> 
                  <img 
                    src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758207263203-image.png" 
                    alt="Attendance Certificate showing detailed session attendance tracking" 
                    className="w-full h-auto rounded-lg border border-white/20" 
                  /> 
                  <div className="text-xs text-white/70 mt-2 text-center"> 
                    Individual session attendance with time tracking 
                  </div> 
                </motion.div> 
              </div> 
            </div> 
            <p className="text-center text-white/90 text-lg"> 
              Your sponsorship delivers measurable professional development value through detailed completion certificates, CPD credits, and individual session tracking - extending engagement and brand association well beyond the live event.
            </p> 
          </motion.div> 
        );
      case 'top-downloads': 
        return ( 
          <motion.div 
            className="bg-gradient-to-br from-proactuary-blue-600/30 to-proactuary-green-600/30 rounded-xl p-6" 
            initial={{opacity: 0,y: 20}} 
            animate={{opacity: 1,y: 0}} 
            exit={{opacity: 0,y: -20}} 
          > 
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center"> 
              <SafeIcon icon={FiDownload} className="text-proactuary-blue-400 mr-3" /> 
              Top Media Downloads 
            </h3> 
            {/* Downloads List */} 
            <div className="space-y-3 mb-6"> 
              {downloadData.map((item,index)=> ( 
                <motion.div 
                  key={index} 
                  className="glass-effect rounded-lg p-4 flex items-center justify-between hover:bg-white/10 transition-colors" 
                  initial={{opacity: 0,x: -20}} 
                  animate={{opacity: 1,x: 0}} 
                  transition={{delay: index * 0.05}} 
                > 
                  <div className="flex items-center space-x-4 flex-1"> 
                    <div className="flex-shrink-0"> 
                      <div className="w-12 h-12 bg-proactuary-blue-500/30 rounded-lg flex items-center justify-center"> 
                        <SafeIcon icon={FiFileText} className="text-proactuary-blue-400 text-xl" /> 
                      </div> 
                    </div> 
                    <div className="flex-1 min-w-0"> 
                      <div className="text-white font-medium text-sm leading-tight"> 
                        {item.title} 
                      </div> 
                      <div className="text-proactuary-blue-300 text-xs mt-1 flex items-center"> 
                        <span className="bg-proactuary-green-500/20 text-proactuary-green-300 px-2 py-1 rounded text-xs"> 
                          {item.type} 
                        </span> 
                      </div> 
                    </div> 
                  </div> 
                  <div className="flex items-center space-x-2 flex-shrink-0"> 
                    <div className="text-right"> 
                      <div className="text-2xl font-bold text-white">{item.downloads}</div> 
                      <SafeIcon icon={FiDownload} className="text-proactuary-green-400 text-sm mx-auto" /> 
                    </div> 
                  </div> 
                </motion.div> 
              ))} 
            </div> 
            {/* Summary Stats */} 
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6"> 
              {[ 
                {number: '4,689',label: 'Total Downloads',icon: FiDownload},
                {number: '375',label: 'Highest Single Download',icon: FiFileText},
                {number: '41',label: 'Attendee Resource Downloads Available',icon: FiBookOpen} 
              ].map((stat,index)=> ( 
                <motion.div 
                  key={index} 
                  className="glass-effect rounded-lg p-4 text-center" 
                  initial={{opacity: 0,scale: 0.8}} 
                  animate={{opacity: 1,scale: 1}} 
                  transition={{delay: 0.6 + index * 0.1}} 
                > 
                  <SafeIcon icon={stat.icon} className="text-proactuary-green-400 text-2xl mx-auto mb-2" /> 
                  <div className="text-2xl font-bold text-white mb-1">{stat.number}</div> 
                  <div className="text-sm text-white/80">{stat.label}</div> 
                </motion.div> 
              ))} 
            </div> 
            <p className="text-center text-white/90 text-lg"> 
              High-value content downloads demonstrate continued engagement with sponsor-branded materials long after the live event,extending your brand exposure and ROI. 
            </p> 
          </motion.div> 
        );
      default: 
        return null;
    }
  };

  return ( 
    <>
      <motion.div 
        className="glass-effect rounded-2xl p-8" 
        initial={{opacity: 0,y: 20}} 
        animate={{opacity: 1,y: 0}} 
        transition={{duration: 0.6}} 
      > 
        <div className="text-center mb-8"> 
          <motion.h2 
            className="text-3xl md:text-4xl font-bold text-white mb-4 flex items-center justify-center" 
            initial={{opacity: 0}} 
            animate={{opacity: 1}} 
            transition={{delay: 0.2}} 
          > 
            <SafeIcon icon={FiActivity} className="text-proactuary-blue-400 mr-3" /> 
            Engagement & Reach Metrics 
          </motion.h2> 
          <div className="w-24 h-1 bg-gradient-to-r from-proactuary-blue-500 to-proactuary-green-500 mx-auto rounded-full" /> 
        </div> 
        <div className="flex flex-wrap justify-center mb-8 glass-effect rounded-xl p-2"> 
          {tabs.map((tab)=> ( 
            <motion.button 
              key={tab.id} 
              className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-semibold transition-all ${activeTab===tab.id ? 'bg-proactuary-blue-500/30 text-white shadow-lg border border-proactuary-blue-400/50' : 'text-white/70 hover:text-white hover:bg-white/10'}`}
              onClick={()=> setActiveTab(tab.id)} 
              whileHover={{scale: 1.05}} 
              whileTap={{scale: 0.95}} 
            > 
              <SafeIcon icon={tab.icon} className="text-lg" /> 
              <span className="hidden sm:inline">{tab.label}</span> 
            </motion.button> 
          ))} 
        </div> 
        <AnimatePresence mode="wait"> 
          {renderTabContent()} 
        </AnimatePresence> 
      </motion.div>

      {/* Live Engagement Modal */}
      <AnimatePresence>
        {showLiveEngagementModal && (
          <motion.div
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[100] flex items-center justify-center p-4"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            onClick={closeLiveEngagementModal}
          >
            <motion.div
              className="bg-gradient-to-br from-proactuary-blue-900 to-proactuary-green-900 rounded-2xl p-6 max-w-5xl w-full max-h-[90vh] overflow-y-auto border border-proactuary-blue-500/50"
              initial={{scale: 0.8,opacity: 0,y: 50}}
              animate={{scale: 1,opacity: 1,y: 0}}
              exit={{scale: 0.8,opacity: 0,y: 50}}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-2xl md:text-3xl font-bold text-white flex items-center">
                  <SafeIcon icon={FiPlay} className="text-proactuary-blue-400 mr-3" />
                  Live Event Engagement Examples
                </h3>
                <motion.button
                  onClick={closeLiveEngagementModal}
                  className="p-2 rounded-lg bg-red-500/20 hover:bg-red-500/40 text-red-400 hover:text-red-300 transition-colors"
                  whileHover={{scale: 1.1}}
                  whileTap={{scale: 0.9}}
                >
                  <SafeIcon icon={FiX} className="text-xl" />
                </motion.button>
              </div>

              {/* Navigation Info */}
              <div className="bg-gradient-to-r from-proactuary-blue-500/20 to-proactuary-green-500/20 rounded-lg p-3 mb-4 border border-proactuary-blue-500/30">
                <p className="text-white/90 text-sm text-center">
                  <strong>{liveEngagementExamples.length} Live Session Screenshots</strong> - Navigate through real examples of audience engagement and Q&A participation
                </p>
              </div>

              {/* Carousel Navigation */}
              <div className="flex items-center justify-between mb-4">
                <motion.button
                  onClick={prevImage}
                  className="p-3 bg-proactuary-blue-500/30 hover:bg-proactuary-blue-500/50 rounded-lg transition-colors"
                  whileHover={{scale: 1.1}}
                  whileTap={{scale: 0.9}}
                  disabled={liveEngagementExamples.length <= 1}
                >
                  <SafeIcon icon={FiChevronLeft} className="text-proactuary-blue-400 text-xl" />
                </motion.button>

                <div className="text-center">
                  <span className="text-white/70 text-sm">
                    {currentImageIndex + 1} of {liveEngagementExamples.length}
                  </span>
                </div>

                <motion.button
                  onClick={nextImage}
                  className="p-3 bg-proactuary-blue-500/30 hover:bg-proactuary-blue-500/50 rounded-lg transition-colors"
                  whileHover={{scale: 1.1}}
                  whileTap={{scale: 0.9}}
                  disabled={liveEngagementExamples.length <= 1}
                >
                  <SafeIcon icon={FiChevronRight} className="text-proactuary-blue-400 text-xl" />
                </motion.button>
              </div>

              {/* Current Image Display */}
              <AnimatePresence mode="wait">
                <motion.div
                  key={currentImageIndex}
                  className="text-center mb-6"
                  initial={{opacity: 0,x: 100}}
                  animate={{opacity: 1,x: 0}}
                  exit={{opacity: 0,x: -100}}
                  transition={{duration: 0.3}}
                >
                  <div className="mb-4">
                    <h4 className="text-xl font-semibold text-white mb-2">
                      {liveEngagementExamples[currentImageIndex].title}
                    </h4>
                  </div>
                  
                  <div className="bg-white/5 rounded-lg p-4 border border-white/20">
                    <img
                      src={liveEngagementExamples[currentImageIndex].image}
                      alt={liveEngagementExamples[currentImageIndex].description}
                      className="w-full h-auto rounded-lg shadow-lg"
                    />
                  </div>
                  
                  <p className="text-white/80 mt-4 text-sm leading-relaxed">
                    {liveEngagementExamples[currentImageIndex].description}
                  </p>
                </motion.div>
              </AnimatePresence>

              {/* Dot Indicators */}
              {liveEngagementExamples.length > 1 && (
                <div className="flex justify-center space-x-2 mb-6 flex-wrap">
                  {liveEngagementExamples.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentImageIndex(index)}
                      className={`w-3 h-3 rounded-full transition-colors mb-1 ${
                        index === currentImageIndex ? 'bg-proactuary-blue-400' : 'bg-white/30'
                      }`}
                    />
                  ))}
                </div>
              )}

              {/* Explanatory Text */}
              <motion.div
                className="bg-gradient-to-r from-proactuary-green-500/20 to-proactuary-blue-500/20 rounded-xl p-6 border border-proactuary-green-500/30"
                initial={{opacity: 0,y: 20}}
                animate={{opacity: 1,y: 0}}
                transition={{delay: 0.3}}
              >
                <h4 className="text-lg font-bold text-white mb-3 flex items-center">
                  <SafeIcon icon={FiUsers} className="text-proactuary-green-400 mr-2" />
                  Comprehensive Live Session Engagement Evidence
                </h4>
                <p className="text-white/90 leading-relaxed">
                  These {liveEngagementExamples.length} live session screenshots demonstrate consistent active attendee participation, real-time Q&A engagement, and professional presentation quality throughout the entire event. Examples include technical discussions on AI agents, risk management, and practical applications - showing sustained audience interaction with expert-led sessions and validating the strong engagement rates achieved during your sponsored summit.
                </p>
                <div className="mt-4 grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-proactuary-green-400 rounded-full mr-2" />
                    <span className="text-white/80">Live Q&A Participation</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-proactuary-blue-400 rounded-full mr-2" />
                    <span className="text-white/80">Technical Discussions</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-proactuary-green-400 rounded-full mr-2" />
                    <span className="text-white/80">Professional Presentation Quality</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-proactuary-blue-400 rounded-full mr-2" />
                    <span className="text-white/80">Sponsor Branding Visible</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-proactuary-green-400 rounded-full mr-2" />
                    <span className="text-white/80">Sustained Engagement</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-proactuary-blue-400 rounded-full mr-2" />
                    <span className="text-white/80">Expert-Led Sessions</span>
                  </div>
                </div>
              </motion.div>

              {/* Close Button */}
              <div className="text-center mt-6">
                <motion.button
                  onClick={closeLiveEngagementModal}
                  className="px-6 py-3 bg-gradient-to-r from-proactuary-blue-500 to-proactuary-green-500 hover:from-proactuary-blue-600 hover:to-proactuary-green-600 text-white font-semibold rounded-lg transition-all duration-300"
                  whileHover={{scale: 1.05}}
                  whileTap={{scale: 0.95}}
                >
                  Close Examples ({liveEngagementExamples.length} Screenshots Viewed)
                </motion.button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  ); 
}; 

export default EngagementTabs;